import axiosInstance from "./axiosInstance";

export const obtenerReservacion = async (titularId, reservacionId) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerReservacion?titularId=${titularId}&reservacionId=${reservacionId} `,
    {
      withCredentials: true,
    }
  );
};
